import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { RadioButtonsGroup } from '~/components';
import { Title, Description } from '../../common';

const ContainerRadioGroup = styled.div`
  margin: 30px 0 0 -123px;
`;

export default function BlockReasons({ selectedCode, reasonList }) {
  return (
    <>
      <Title marginBottom="20px">Bloquear cartão</Title>
      <Description>Qual o motivo do bloqueio?</Description>
      <ContainerRadioGroup>
        <RadioButtonsGroup
          ariaLabel="Motivos para bloqueio"
          name="block_reasons"
          list={reasonList}
          selectedCode={value => selectedCode(value)}
        />
      </ContainerRadioGroup>
    </>
  );
}

BlockReasons.propTypes = {
  selectedCode: PropTypes.func.isRequired,
  reasonList: PropTypes.array.isRequired,
};
